<template>
  <MarketingOutOfCoverageCustomers v-if="initialData" v-bind="initialData" />
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue";

import MarketingOutOfCoverageCustomers from "@/Marketing/MarketingOutOfCoverageCustomers.vue";

const initialData = ref<{
  filters: [];
  source: string;
} | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();
});
</script>
